import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UtilitaService } from '../services/utilita.service';
import { UtentiDettaglioComponent } from './utenti-dettaglio/utenti-dettaglio.component';
import { VerificaUtenteComponent } from './verifica-utente/verifica-utente.component';

@Component({
  selector: 'app-utenti',
  templateUrl: './utenti.component.html',
  styleUrls: ['./utenti.component.css']
})
export class UtentiComponent implements OnInit {
  lstAtenei: any;
  lstElencoAteneo: any
  lstElencoDipartimento: any;
  lstElenco: any;
  lstElencoVerificati: any;
  lstElencoPerUpdateFilter: any;
  txtFiltra: any;

  txtisVerificato: string = '-1'
  txtCognome: string = '';
  txtNome: string = '';
  txtEmail: string = '';
  txtAteneo: string = "";
  txtDipartimento: string = "";
  txtCodiceFiscale: string = '';

  constructor(private srvUtilita: UtilitaService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getAteneo();
     
    //  this.getLista(this.txtCognome, this.txtNome, this.txtEmail, this.txtAteneo, this.txtDipartimento, this.txtCodiceFiscale);
   
  }

  getAteneo() {
    this.srvUtilita.getLista('Utenti/GetAteneiLista').subscribe((res: any) => {
      this.lstElencoAteneo = res
      this.getDipartimenti('');

      this.getLista(this.txtisVerificato, this.txtCognome, this.txtNome, this.txtEmail, this.txtAteneo, this.txtDipartimento, this.txtCodiceFiscale);
    
    })
  }

  getDipartimenti(idAteneo: any) {
    this.srvUtilita.getLista('Utenti/GetDipartimentiLista?idAteneo=' + idAteneo).subscribe((res: any) => {
      this.lstElencoDipartimento = res
      //  console.log('this.lstElenco', res)
    }, (err: any) => {
    })
  }

  getLista(isVerificato: any, sCognome: string, sNome: string, sEmail: string, iAteneo: any, iDipartimento: any, sCodiceFiscale: any) {
    let ateneo: any = this.txtAteneo;
    if (!ateneo) ateneo = 0;

    let dipartimento: any = this.txtDipartimento;
    if (!dipartimento) dipartimento = 0;

    this.srvUtilita.getLista('Utenti/GetUtentiLista?isVerificato=' + this.txtisVerificato + '&sCognome=' + sCognome + '&sNome=' + sNome + '&sEmail=' + sEmail
      + '&iAteneo=' + ateneo + '&iDipartimento=' + dipartimento + '&sCodiceFiscale=' + sCodiceFiscale).subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
      //  console.log('this.lstElenco', res)
    }, (err: any) => {
    })
  }


  btnCerca() {
    this.txtFiltra = '';
    this.getLista(this.txtisVerificato, this.txtCognome, this.txtNome, this.txtEmail, this.txtAteneo, this.txtDipartimento, this.txtCodiceFiscale);
  }

  btnAggiungiModifica(iValore: number) {
    // console.log('ivalore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(UtentiDettaglioComponent, {
      width: '720px',
      disableClose: false,
      data: { iValore: iValore }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista(this.txtisVerificato, this.txtCognome, this.txtNome, this.txtEmail, this.txtAteneo, this.txtDipartimento, this.txtCodiceFiscale);
      }) 
  }

  btnVerificaUtente(iValore: any) {
   // console.log('iValore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(VerificaUtenteComponent, {
      width: '720px',
      disableClose: false,
      data: { iValore: iValore }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista(this.txtisVerificato, this.txtCognome, this.txtNome, this.txtEmail, this.txtAteneo, this.txtDipartimento, this.txtCodiceFiscale);
      }) 
  }


  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }

}
